<div data-cy="datepicker-map__page" class="inputDate" *ngIf="layout == 'chart'">
  <mat-form-field appearance="outline" class="custom-date-range-set">
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" class="map-datepicker-input">
      <input data-cy="datepicker-map__start-input" matStartDate formControlName="start" placeholder="Start date" class="map-start-datepicker-input">
      <input data-cy="datepicker-map__end-input" matEndDate formControlName="end" placeholder="End date" [max]="maxDate" class="map-end-datepicker-input">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker" class="map-date-range-picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
   <!-- Add Close Icon -->
   <mat-icon data-cy="datepicker-map__reset-filter"
   class="close-icon-set"
   *ngIf="showResetIcon && (range.get('start').value || range.get('end').value)"
    (click)="resetFilter()">
   close
 </mat-icon>
</div>
